import { UserTier } from "./types";

export const SUPPORTED_LANGUAGES = [
  // Basic
  "English", "Spanish", "French", "German", "Portuguese", 
  // European
  "Italian", "Dutch", "Russian", "Polish", "Ukrainian", "Swedish", "Danish", "Norwegian", "Finnish", "Greek", "Czech", "Romanian", "Hungarian", "Bulgarian", "Croatian", "Serbian", "Slovak", "Lithuanian",
  // Asian
  "Japanese", "Chinese (Simplified)", "Chinese (Traditional)", "Korean", "Thai", "Vietnamese", "Indonesian", "Malay", "Filipino", "Hindi", "Bengali", "Urdu", "Tamil", "Telugu", "Marathi", "Gujarati", "Kannada",
  // Middle Eastern / Other
  "Arabic", "Turkish", "Hebrew", "Persian", "Swahili"
];

export const BASIC_LANGUAGES = ["English", "Spanish", "French", "German", "Portuguese"];

interface PlanConfig {
  maxDurationSeconds: number; // in seconds
  allowedLanguages: string[] | 'all';
  storageRetentionDays: number;
  label: string;
}

export const PLAN_LIMITS: Record<UserTier, PlanConfig> = {
  free: {
    maxDurationSeconds: 180, // 3 mins max (Same as Starter for trial)
    allowedLanguages: BASIC_LANGUAGES,
    storageRetentionDays: 1, // 24h
    label: 'Free Trial'
  },
  starter: {
    maxDurationSeconds: 180, // 3 mins max (Critical for $4 cost)
    allowedLanguages: BASIC_LANGUAGES,
    storageRetentionDays: 1, // 24h cleanup
    label: 'Starter'
  },
  creator: {
    maxDurationSeconds: 900, // 15 mins
    allowedLanguages: 'all', // Unlocks +40 languages
    storageRetentionDays: 7,
    label: 'Creator'
  },
  pro: {
    maxDurationSeconds: 3600, // 60 mins
    allowedLanguages: 'all',
    storageRetentionDays: 30,
    label: 'Pro Agency'
  }
};

export const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    price: 4,
    credits: 10,
    tier: 'starter' as UserTier,
    features: ['3 min max duration', '5 Basic Languages', '24h Storage', 'Perfect for TikTok/Reels'],
    recommended: false
  },
  {
    id: 'creator',
    name: 'Creator',
    price: 10,
    credits: 30,
    tier: 'creator' as UserTier,
    features: ['15 min max duration', 'All 45+ Languages', '7-Day Storage', 'Priority Processing'],
    recommended: true
  },
  {
    id: 'pro',
    name: 'Pro Agency',
    price: 25,
    credits: 100,
    tier: 'pro' as UserTier,
    features: ['60 min max duration', 'All Languages', '30-Day Storage', 'Commercial Use'],
    recommended: false
  }
];